import { Button, Popover } from 'antd';
import { useTranslate } from '@tolgee/react';
import ContactContent from 'views/Main/components/AppHeader/components/ContactContent';
import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';
import Empty from 'views/Aide/components/Empty';
import noPermissionImage from 'views/Aide/assets/noPermission.png';
import { isMasterOnline, isSiteGiant } from 'productLine';

function NotOpen() {
  const { t } = useTranslate();

  const { qaQrcode } = useFlagConfigValue();

  return (
    <Empty>
      <img src={noPermissionImage} alt="noPermission" />
      <p>{isMasterOnline || isSiteGiant ? t('aide.绩效提示1copy') : t('aide.绩效提示1')}</p>
      <p>
        <div>{t('aide.绩效提示2')}</div>
        <div>{t('aide.绩效提示3')}</div>
        <div>{t('aide.绩效提示4')}</div>
        <div>{t('aide.绩效提示5')}</div>
      </p>
      {isMasterOnline || isSiteGiant ? null : (
        <Popover placement="bottom" content={<ContactContent qrCode={qaQrcode} />}>
          <Button type="primary">{t('aide.联系我们立即解锁')}</Button>
        </Popover>
      )}
    </Empty>
  );
}

export default NotOpen;
